<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <i class="el-icon-food" style="font-size: 40px; color: #67c23a;"></i>
        <h2>爱心食物银行</h2>
        <p>管理后台登录</p>
      </div>

      <el-form ref="loginForm" :model="form" :rules="rules" label-width="0" class="login-form">


        <el-form-item prop="account">
          <el-input
            v-model="form.account"
            placeholder="请输入账号"
            prefix-icon="el-icon-user"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            class="login-btn"
            @click="handleLogin"
          >
            {{ loading ? '登录中...' : '登 录' }}
          </el-button>
        </el-form-item>
      </el-form>

      <div class="login-footer">
        <span>© 2026 爱心食物银行</span>
      </div>
    </div>

    <!-- 滑动验证码：pop 弹窗模式 -->
    <Verify
        ref="verify"
        :captcha-type="captchaType"
        :mode="'pop'"
        :img-size="{ width: '330px', height: '155px' }"
        @success="captchaSuccess"
        @error="captchaError"
    />
  </div>
</template>

<script>
import { adminLogin } from '@/api/auth'
import { mapActions } from 'vuex'

import Verify from '@/components/verifition/Verify'

export default {
  name: 'Login',
  components: { Verify },
  data() {
    return {
      captchaType: 'blockPuzzle',
      loading: false,
      captchaVerification: '',   // 验证码一次性凭证，不进表单校验
      form: {
        account: '',
        password: '',
        type: 'admin'
      },
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 4, message: '密码至少4位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['login']),
    // 点登录 → 先校验表单 → 弹验证码（不直接请求登录接口）
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) return
        if (this.loading) return
        this.$refs.verify.show()
      })
    },

    // 滑动验证通过 → 带凭证调登录
    async captchaSuccess(params) {
      this.captchaVerification = params.captchaVerification
      this.loading = true
      try {
        const res = await adminLogin(
            this.form.account,
            this.form.password,
            this.form.type,
            this.captchaVerification
        )
        const token = res.token || 'mock-token'
        const userInfo = res.userInfo || { account: this.form.account, name: this.form.account }
        this.login({ token, userInfo, type: this.form.type })
        this.$message.success('登录成功')
        this.$router.push('/dashboard')
      } catch (e) {
        this.$message.error((e && e.message) || '登录失败，请重试')
      } finally {
        this.loading = false
        // 凭证一次性，用完清空；下次点登录会重新弹验证码重新获取
        this.captchaVerification = ''
      }
    },

    captchaError() {
      this.$message.warning('验证未通过，请重新完成滑动验证')
    }
  }
}
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}
.login-container::before {
  content: '';
  position: absolute;
  width: 600px;
  height: 600px;
  border-radius: 50%;
  background: rgba(255,255,255,0.05);
  top: -200px;
  left: -200px;
}
.login-container::after {
  content: '';
  position: absolute;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: rgba(255,255,255,0.05);
  bottom: -100px;
  right: -100px;
}
.login-box {
  width: 420px;
  background: #fff;
  border-radius: 12px;
  padding: 40px 36px 30px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  z-index: 1;
}
.login-header {
  text-align: center;
  margin-bottom: 30px;
}
.login-header h2 {
  margin: 12px 0 4px;
  color: #303133;
  font-size: 22px;
}
.login-header p {
  color: #909399;
  font-size: 14px;
}
.login-type {
  width: 100%;
  display: flex;
}
.login-type .el-radio-button {
  flex: 1;
}
.login-type .el-radio-button__inner {
  width: 100%;
}
.login-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  letter-spacing: 4px;
}
.login-footer {
  text-align: center;
  margin-top: 20px;
  color: #c0c4cc;
  font-size: 12px;
}
</style>
